import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryIdData from './GetOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryIdData';
import postOrgUnitAthleteEntryPurchaseData from './PostOrgUnitAthleteEntryPurchaseData';
import deleteOrgUnitAthleteEntryPurchaseData from './DeleteOrgUnitAthleteEntryPurchaseData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OrgUnitAthleteEntryPurchaseData = {
  INITIAL_STATE, getOrgUnitAthleteEntryPurchaseByOrgUnitAthleteEntryIdData,
  postOrgUnitAthleteEntryPurchaseData, deleteOrgUnitAthleteEntryPurchaseData
};

export default OrgUnitAthleteEntryPurchaseData;